import { useDispatch } from 'react-redux';
import { locizeNS } from 'Services/i18n';
import { history } from 'Store';
import { showModalAction } from 'Store/modules/app/actions';
import useTranslation from 'Hooks/useTranslation';
import { TaxReturnTypes } from 'Containers/Result/utils';
import FormEfirma from 'Components/FormEfirma';
import { FRONT_PLANS, getLocizeKey, parsePlans, PLANS_MODE } from 'Constants/plans';
import { routes } from 'Constants/routes';
import { EFIRMA_MODAL } from 'Constants/modals';
import { setBodyOverflow } from 'Styles/utils/utils';
import { ButtonPlanProps } from './types';
import * as Styled from './styles';

const ButtonPlan = ({ onClick, name, data }: ButtonPlanProps): JSX.Element => {
  const { t } = useTranslation(locizeNS.PLANS);
  const dispatch = useDispatch();
  const handleClickPayLater = (): void => {
    if (
      data &&
      Math.abs(data.taxReturnResult) > 9999 &&
      data.taxReturnType === TaxReturnTypes.TO_RETURN
    ) {
      setBodyOverflow();
      dispatch(
        showModalAction({
          options: { type: EFIRMA_MODAL, data: { result: data } },
          Component: FormEfirma,
        })
      );
    } else {
      history.push(routes.PAYMENT_LATER, {
        route: routes.RESULT,
        section: 'result',
        taxReturnType: data?.taxReturnType,
        taxReturnResult: data?.taxReturnResult,
      });
    }
  };

  if (parsePlans(name) === FRONT_PLANS.FLEX) {
    return (
      <Styled.CheckoutButton
        label={
          t(`Plans.payLater.get`, { context: data && data.taxReturnResult }) ||
          t(`Plans.payLater.suscribed`)
        }
        mode="live"
        onClick={handleClickPayLater}
        size="m"
        testID={`select-plan-${parsePlans[name]}`}
      />
    );
  }

  return (
    <Styled.CheckoutButton
      label={t(getLocizeKey(parsePlans(name), 'button'))}
      mode={PLANS_MODE[parsePlans(name)]}
      onClick={onClick}
      size="m"
    />
  );
};

export default ButtonPlan;
